import * as E from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/function';
import { ApiError, decoder, ParsedError, transform } from '.';
import { DECODE_ERROR } from '../../fetch';
import * as Sentry from '@sentry/browser';
import { Errors } from 'io-ts';
import { failure } from 'io-ts/PathReporter';

export const decodeError = (error: ParsedError) => pipe(
  error.parsed,
  decoder.decode,
  E.fold(
    // this is not really a 500 error, but since we can't decode it
    // we must treat it as a server error, as the server broke the contract
    (errors: Errors) => {
      const stringErrors = failure(errors).join('\n');

      // debug output
      console.error(stringErrors);
      console.error(errors);
      Sentry.withScope(scope => {
        scope.setExtra('decodeErrors', JSON.stringify(errors));
        Sentry.captureException(stringErrors);
      });

      return new ApiError(DECODE_ERROR, 'error decoding error json');
    },
    decodedErrorBody => {
      return decodedErrorBody.errors
        ? new ApiError(error.code, 'validation error', transform(decodedErrorBody.errors))
        : new ApiError(error.code, decodedErrorBody.message ?? 'server error');
    },
  ),
);
